<template lang="pug">
  v-container#dashboard.summary-container(fluid='' tag='section')
    //- Products preview
    v-dialog( :fullscreen='isMobile' persistent :key='currentItem.name' :value='dialogProductPreview'  max-width='800px'   transition="dialog-bottom-transition")
        div(style ='position:relative; height: 100%;')
          Preview(:model='currentItem' v-if="dialogProductPreview" @close="dialogProductPreview=false" @edit="editItem(currentItem.id)"  @delete="openDeleteDialog(currentItem)" :showOptions="true")
    //- Products update
    v-dialog(  :fullscreen='isMobile' persistent :key='currentItem.id' :value='updateItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
        div(style ='position:relative; height: 100%;')
          update-item(:model='currentItem' v-if='updateItemDialog' @close="updateItemDialog=false;dialogProductPreview=true")
    //- Products delete
    v-dialog( v-model='confirmationDialog' width="500px" persistent transition="dialog-bottom-transition")
        v-card(outlined).card__confirmation-dialog
          v-card-title
            | Eliminar Producto
            v-spacer
              v-icon(aria-label="Close" @click="confirmationDialog = false")
                | mdi-close
          v-card-text.body-1.text-center
            | ¿Esta seguro de eliminar este Producto? {{isLastProductInshop ? 'se desactivaran las siguientes tiendas virtuales: ' + virtualShopsNamesToDelete : ''}}
          v-card-actions.text-center
            v-spacer
              v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') No, cancelar
              v-btn(color='red darken-1', flat='', @click.native='deleteItem(currentItem)') Si, procede
    //- Content
    v-row.my-1.justify-space-between.align-center
      //- Dates
      v-col.px-0(cols="6" xs="6" sm="6" md="6")
        p(style="font-size: 15px") {{from === '' ? 'Ventas realizadas en 7 días' : 'Ventas desde ' + from + ' hasta ' + to + ''}}
      //- Filter date
      v-col.d-flex.justify-end.px-0(cols="6" xs="6" sm="6" md="6")
        v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
          template(v-slot:activator='{ on }')
            v-btn.main-btn-gradient(color='#3cbbc2', dark small v-on='on' style="height: 48px;").mt-0
              v-icon mdi-calendar
              p filtrar
          v-card(style="border:3px solid #3cbbc2;").pa-2
            date-filter(@closeMenu="filterSummary($event)" :currentType='currentType',)
    v-row.pb-5.mt-0
      Movements.mb-10(v-if="!loading" title="Movimientos" :shop="shopId" :fromParent="fromParent" :toParent="toParent")
      v-skeleton-loader.my-10(v-else width='100%' height="150" type="card")
      //- Graphics
      v-skeleton-loader(v-if="loading" width='100%' height="50" type="card")
      v-tabs.rounded-lg(v-else v-model="tab" align-with-title="" show-arrows)
        v-tabs-slider(color="primary")
        v-tab(@click="loadGraphic") Ventas/Utilidad
        //- {{numberFormat(summary.sales.total)}}
        //- v-tab(@click="loadGraphic") Utilidad {{ numberFormat(summary.revenue.total)}}
        //- v-tab(@click="loadGraphic") Ordenes {{ numberFormat(summary.orders.total)}}
        v-tab Resumen de inventario
        v-tab Colaboradores
        v-tab Top más vendidos
        v-tab(@click="loadCategoryAnalytics") Categorías
        //- Sales/utility
        v-tab-item
          v-card.card-tabs.pa-2
            v-row
              v-col(cols='12' md="6" class="small")
                v-skeleton-loader.mx-auto(:transition='transition' v-if='summary.sales.isLoading || plotLoading'  type='card')
                BarChart(v-else :chart-data='summary.sales' :options="optionsChartsSalesOrders")
              v-col(cols='12' md="6" class="small")
                v-skeleton-loader.mx-auto(:transition='transition' v-if='summary.revenue.isLoading || plotLoading'  type='card')
                BarChart(v-else :chart-data='summary.revenue' :options="optionsChartsRevenue")

            //- Category Metrics Section
            v-row.mt-4
              v-col(cols="12")
                v-card.elevation-2
                  v-card-title
                    v-icon.mr-2(color="primary") mdi-chart-pie
                    | Métricas por Categorías
                  v-card-text
                    v-row
                      //- Category Stats Cards
                      v-col(cols="12" md="3")
                        v-card.pa-3.text-center(outlined)
                          v-icon.mb-2(size="40" color="success") mdi-tag-multiple
                          h3.primary--text {{ categoryStats.totalCategories }}
                          p.caption Categorías Activas
                      v-col(cols="12" md="3")
                        v-card.pa-3.text-center(outlined)
                          v-icon.mb-2(size="40" color="info") mdi-currency-usd
                          h3.primary--text ${{ categoryStats.totalRevenue | numberFormat }}
                          p.caption Ingresos Totales
                      v-col(cols="12" md="3")
                        v-card.pa-3.text-center(outlined)
                          v-icon.mb-2(size="40" color="warning") mdi-trending-up
                          h3.primary--text {{ categoryStats.revenueGrowth }}%
                          p.caption Crecimiento
                      v-col(cols="12" md="3")
                        v-card.pa-3.text-center(outlined)
                          v-icon.mb-2(size="40" color="orange") mdi-calculator
                          h3.primary--text ${{ categoryStats.avgOrderValue | numberFormat }}
                          p.caption Valor Promedio

                    v-row.mt-4
                      //- Category Revenue Chart
                      v-col(cols="12" md="8")
                        v-card.pa-3
                          h4.mb-3 Ingresos por Categoría
                          v-skeleton-loader(v-if="categoryAnalyticsLoading" type="card")
                          BarChart(v-else-if="categoryRevenueChartData.labels.length > 0" :chart-data="categoryRevenueChartData" :options="categoryChartOptions")
                          p.text-center.mt-4(v-else) No hay datos de categorías disponibles

                      //- Category Distribution Pie Chart
                      v-col(cols="12" md="4")
                        v-card.pa-3
                          h4.mb-3 Distribución de Ventas
                          v-skeleton-loader(v-if="categoryAnalyticsLoading" type="card")
                          PieChart(v-else-if="categoryDistributionData.labels.length > 0" :chart-data="categoryDistributionData" :options="pieChartOptions")
                          p.text-center.mt-4(v-else) No hay datos disponibles

                    v-row.mt-4
                      //- Top Categories Table
                      v-col(cols="12")
                        v-card
                          v-card-title
                            v-icon.mr-2(color="success") mdi-trophy
                            | Top Categorías por Rendimiento
                          v-data-table(
                            :headers="topCategoriesHeaders"
                            :items="topCategories"
                            :items-per-page="5"
                            hide-default-footer
                            :loading="categoryAnalyticsLoading"
                          )
                            template(v-slot:item.growth="{ item }")
                              v-chip(
                                :color="item.growth >= 0 ? 'success' : 'error'"
                                text-color="white"
                                small
                              ) {{ item.growth >= 0 ? '+' : '' }}{{ item.growth }}%
                            template(v-slot:item.revenue="{ item }")
                              span.font-weight-bold.success--text ${{ item.revenue | numberFormat }}
                            template(v-slot:item.previousRevenue="{ item }")
                              span.grey--text ${{ item.previousRevenue | numberFormat }}
                            template(v-slot:item.revenueChange="{ item }")
                              span(:class="item.revenueChange >= 0 ? 'success--text' : 'error--text'") 
                                | {{ item.revenueChange >= 0 ? '+' : '' }}${{ Math.abs(item.revenueChange) | numberFormat }}
                            template(v-slot:item.transactions="{ item }")
                              span.font-weight-bold {{ item.transactions }}
                            template(v-slot:item.previousTransactions="{ item }")
                              span.grey--text {{ item.previousTransactions }}
                            template(v-slot:item.quantity="{ item }")
                              span {{ item.quantity }}
        //- Table inventory
        v-tab-item
          v-card.card-tabs.pa-2
            //- Filter
            v-row.justify-space-between
              v-col(cols="6" xs="6" sm="6" md="4")
                v-select.elevation-0.my-0.py-0.rounded-xl(
                  v-if="!shopId"
                  label='Seleccina una tienda...',
                  :items='shops',
                  v-model="selectedShop"
                  item-text='name',
                  return-object,
                  outlined,
                  dense,
                  width="200"
                  clearable='')
                    template(slot='selection', slot-scope='data')
                      v-flex(xs2='')
                        v-avatar(size='25px')
                          img( style='object-fit:cover;' :src="data.item.pictures.imageInput1 === '' ? allCategorys : data.item.pictures.imageInput1")
                      v-flex.ml-1(style='font-size:10px;')
                        | {{ data.item.name }}
                    template(slot='item', slot-scope='data')
                      v-avatar(size='25px')
                        img(style='object-fit:cover;' :src="data.item.pictures.imageInput1 === '' ? allCategorys : data.item.pictures.imageInput1")
                      v-list-item-content
                        v-list-item-title(v-html='data.item.name')
              v-btn.main-btn-gradient(v-if="inventoryMetrics.length > 0" @click="onexport()" dark small style="height: 48px;").ma-2.mr-6
                v-icon mdi-arrow-collapse-down
                | Exportar
            //- Table
            v-data-table.show-table-desktop.mt-3(v-if='!!inventoryMetrics && !loadinginventoryMetrics' :headers="headers" :items="inventoryMetrics" :custom-sort="customSort") <!--   -->
              template(v-slot:item="{ item }")
                tr(:key="item.id" @click="showItem(item)" style="cursor: pointer;")
                  td
                    v-img.mx-auto(contain :src="getImage(item.img)" height="65" max-width="50")
                  td.primary--text.hover-cursor(v-text="item.name").product__title--table
                  td.text-left(v-text="item.magnitude ? item.amountTopSales + ' ' + item.unit : item.amountTopSales")
                  td.text-left(v-if="shopId !== ''" v-text="item.magnitude ? item.totalSale + ' ' + item.unit : item.totalSale")
                  td.text-left(v-if="shopId !== ''" v-text="getProductUtility(item)")
                  td.text-left(v-if="shopId !== ''" v-text="getPorcentualProductUtility(item)")
                  td.text-left(v-if="shopId !== ''" v-text="'$ ' + (parseFloat(item.amountTopSales) * parseFloat(item.totalSale))")
                  td.text-left(v-if="shopId !== ''" v-text="'$ ' + item.amountTopSales *  parseFloat(getProductUtility(item).split(' ')[1])")
                  td(v-text="item.stock || 0")
                  td.text-left(v-if="shopId !== ''" v-text="getInventoryTotalUtility(item)")
            //- Mobile
            v-row.show-table-mobile
              template(v-if='!loadinginventoryMetrics && inventoryMetrics.length > 0' v-for='(item, index) in inventoryMetrics')
                v-col(@click="showItem(item)" cols="12" xs="12" sm="6" md="6")
                  v-row.product
                    v-col(cols="12" :class="`product__title-area--${item.type}`").product__title-area
                      span.product__title {{item.name}}
                    v-col(cols="3").px-0
                      img(:src="getImage(item.img)").product__img
                    v-col(cols="9")
                      v-row.ml-0
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title P. Venta
                          span.product__item-amount {{item.magnitude ? item.totalSale + ' ' + item.unit : item.totalSale}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title Utilidad
                          span.product__item-amount.product__item-amount--utility {{getProductUtility(item)}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title % Utilidad
                          span.product__item-amount.product__item-amount--utility {{getPorcentualProductUtility(item)}}
                        v-col(cols="4" v-if="!item.type || item.type==='product' || item.type==='bundle'").ma-0.pa-0
                          span.product__item-title Inventario
                          span.product__item-amount {{item.stock}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title Utilidad en Inventario
                          span.product__item-amount {{getInventoryTotalUtility(item)}}
                        v-col(cols="4" v-if="!item.type || item.type==='product' || item.type==='bundle'").ma-0.pa-0
                          span.product__item-title Vendidos
                          span.product__item-amount {{item.magnitude ? item.amountTopSales + ' ' + item.unit : item.amountTopSales}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title T. vendido
                          span.product__item-amount {{'$ ' + item.amountTopSales * item.totalSale}}
              template(v-if="!loadinginventoryMetrics && inventoryMetrics.length == 0")
                no-results(title="No hay datos disponibles", description="Puedes ver tu resumen de inventario en otro rango de fechas")
        //- Collaborators
        v-tab-item
          v-card.card-tabs.pa-2
            v-card-subtitle
              v-row
                v-col(cols="6")
                  p Ventas realizadas por cada colaborador ($)
                v-col.d-flex.justify-center(v-if="!isMobile" cols="6")
                  p Se han realizado {{totalAmountSalesCollabs}} ventas
            v-card-text
              v-col(cols='12' class="small")
                v-skeleton-loader.mx-auto(:transition='transition' type='card' v-if='collabsIsLoading || plotLoading')
                PieChart(v-else-if="collaborators.labels.length > 0" :chart-data='collaborators' :options="optionsPieCharts")
                p.text-center(v-else-if="collaborators.labels.length === 0") No se realizaron ventas en este periodo de tiempo
              p(v-if="isMobile" style="padding-top: 20px;") Se han realizado {{totalAmountSalesCollabs}} ventas
        //- Top 20
        v-tab-item
          v-card.card-tabs.pa-2
            h2 Top 20 de los más vendidos
            v-row.fill-height
              v-col.text-center(v-if="top20Items.length > 0" v-for='item in top20Items' :key="item.id" cols="6" xs="6" sm="3" md="2" lg="2" xl="1")
                v-card.product-card(@click="showItem(item)" style="cursor: pointer;")
                  .product-card__tag
                    p(v-if='item.name') {{item.magnitude ? item.name + ' x ' + item.unit : item.name}}
                  .product-card__background.d-flex.justify-center
                    v-img(:src="item.img === '' ? allCategorys : item.img" width="128" height="128" contain)
                      template(v-slot:placeholder="")
                        v-row.fill-height.ma-0(align="center" justify="center")
                          v-progress-circular(indeterminate="" color="primary")
                  .product-card__description
                    p {{'cantidad: ' + item.amountTopSales}} {{item.magnitude ? item.unit : ''}}
              no-results(v-else title="Aún no tienes productos más vendidos")
        //- Categories Tab
        v-tab-item
          v-card.card-tabs.pa-2
            v-card-title
              v-icon.mr-2(color="primary") mdi-tag-multiple
              | Métricas por Categorías
            v-card-text
              v-row
                //- Category Stats Cards
                v-col(cols="12" md="3")
                  v-card.pa-3.text-center(outlined)
                    v-icon.mb-2(size="40" color="success") mdi-tag-multiple
                    h3.primary--text {{ categoryStats.totalCategories }}
                    p.caption Categorías Activas
                v-col(cols="12" md="3")
                  v-card.pa-3.text-center(outlined)
                    v-icon.mb-2(size="40" color="info") mdi-currency-usd
                    h3.primary--text ${{ categoryStats.totalRevenue | numberFormat }}
                    p.caption Ingresos Totales
                v-col(cols="12" md="3")
                  v-card.pa-3.text-center(outlined)
                    v-icon.mb-2(size="40" color="warning") mdi-trending-up
                    h3.primary--text {{ categoryStats.revenueGrowth }}%
                    p.caption Crecimiento
                v-col(cols="12" md="3")
                  v-card.pa-3.text-center(outlined)
                    v-icon.mb-2(size="40" color="orange") mdi-calculator
                    h3.primary--text ${{ categoryStats.avgOrderValue | numberFormat }}
                    p.caption Valor Promedio

              v-row.mt-4
                //- Category Revenue Chart
                v-col(cols="12" md="8")
                  v-card.pa-3
                    h4.mb-3 Ingresos por Categoría (Últimos 7 días)
                    v-skeleton-loader(v-if="categoryAnalyticsLoading" type="card")
                    BarChart(v-else-if="categoryRevenueChartData.labels.length > 0" :chart-data="categoryRevenueChartData" :options="categoryChartOptions")
                    p.text-center.mt-4(v-else) No hay datos de categorías disponibles

                //- Category Distribution Pie Chart
                v-col(cols="12" md="4")
                  v-card.pa-3
                    h4.mb-3 Distribución de Ventas
                    v-skeleton-loader(v-if="categoryAnalyticsLoading" type="card")
                    PieChart(v-else-if="categoryDistributionData.labels.length > 0" :chart-data="categoryDistributionData" :options="pieChartOptions")
                    p.text-center.mt-4(v-else) No hay datos disponibles

              v-row.mt-4
                //- Top Categories Table
                v-col(cols="12")
                  v-card
                    v-card-title.mb-2
                      v-icon.mr-2(color="success") mdi-trophy
                      | Top Categorías por Rendimiento
                    v-card-subtitle(v-if="categoryAnalytics.daily._dateRange")
                      | Comparando período actual ({{ formatDateRange(categoryAnalytics.daily._dateRange.currentFrom, categoryAnalytics.daily._dateRange.currentTo) }})
                      | vs período anterior ({{ formatDateRange(categoryAnalytics.daily._dateRange.previousFrom, categoryAnalytics.daily._dateRange.previousTo) }})
                    v-data-table(
                      :headers="topCategoriesHeaders"
                      :items="topCategories"
                      :items-per-page="10"
                      hide-default-footer
                      :loading="categoryAnalyticsLoading"
                    )
                      template(v-slot:item.growth="{ item }")
                        v-chip(
                          :color="item.growth >= 0 ? 'success' : 'error'"
                          text-color="white"
                          small
                        ) {{ item.growth >= 0 ? '+' : '' }}{{ item.growth }}%
                      template(v-slot:item.revenue="{ item }")
                        span.font-weight-bold.success--text ${{ item.revenue | numberFormat }}
                      template(v-slot:item.previousRevenue="{ item }")
                        span.grey--text ${{ item.previousRevenue | numberFormat }}
                      template(v-slot:item.revenueChange="{ item }")
                        span(:class="item.revenueChange >= 0 ? 'success--text' : 'error--text'") 
                          | {{ item.revenueChange >= 0 ? '+' : '' }}${{ Math.abs(item.revenueChange) | numberFormat }}
                      template(v-slot:item.transactions="{ item }")
                        span.font-weight-bold {{ item.transactions }}
                      template(v-slot:item.previousTransactions="{ item }")
                        span.grey--text {{ item.previousTransactions }}
                      template(v-slot:item.quantity="{ item }")
                        span {{ item.quantity }}
        //- v-if="loading && (!isMobile || (isMobile && tab >= 0))"
        //- v-col(cols="12" style="overflow: hidden").text-center
          v-row.my-2
            v-skeleton-loader( v-for='i in 7' max-width="110px" max-height='110px' width='100%' height='110px' type="card").mx-auto.my-2
      //- ORDERS
        v-tabs-items(v-model="tab" v-if="!isMobile || (isMobile && tab >= 0)")
          v-tab-item
            v-card(flat="")
              v-col(cols='12' class="small")
                v-skeleton-loader.mx-auto(:transition='transition' v-if='summary.orders.isLoading || plotLoading'  type='card')
                LineChart(v-else :chart-data='summary.orders' :options="optionsChartsSalesOrders")
                // base-material-chart-card(v-else :data='summary.orders'  :options='options' color='#777'  type='Line')
                  h3.card-title.font-weight-light.mt-2.ml-2
                    | {{summary.orders.total}} {{$t('metrics_summary.orders_to_vsh')}}
            v-card(tile v-if='!change' style="postion: relative;").ma-0
              v-data-table(v-if='!isMobile && !!inventoryMetrics  && !loadinginventoryMetrics' :headers="headers" :items="inventoryMetrics" :custom-sort="customSort") <!--   -->
                template(v-slot:item="{ item }")
                  tr(:key="item.id" @click="showItem(item)" style="cursor: pointer;")
                    td
                      v-img.mx-auto(contain :src="getImage(item.img)" height="65" max-width="50")
                    td.primary--text.display-2.hover-cursor(v-text="item.name").product__title--table
                    td.text-left(v-text="item.magnitude ? item.amountTopSales + ' ' + item.unit : item.amountTopSales")
                    td.text-left(v-if="shopId !== ''" v-text="item.magnitude ? item.totalSale + ' ' + item.unit : item.totalSale")
                    td.text-left(v-if="shopId !== ''" v-text="getProductUtility(item)")
                    td.text-left(v-if="shopId !== ''" v-text="getPorcentualProductUtility(item)")
                    td.text-left(v-if="shopId !== ''" v-text="'$ ' + (parseFloat(item.amountTopSales) * parseFloat(item.totalSale))")
                    td.text-left(v-if="shopId !== ''" v-text="'$ ' + item.amountTopSales *  parseFloat(getProductUtility(item).split(' ')[1])")
                    td(v-text="item.stock || 0")
                    td.text-left(v-if="shopId !== ''" v-text="getInventoryTotalUtility(item)")
              template(v-if='isMobile && !loadinginventoryMetrics && !!inventoryMetrics' v-for='(item, index) in inventoryMetrics')
                v-col(@click="showItem(item)" cols="12")
                  v-row.product
                    v-col(cols="12" :class="`product__title-area--${item.type}`").product__title-area
                      span.product__title {{item.name}}
                    v-col(cols="3").px-0
                      img(:src="getImage(item.img)").product__img
                    v-col(cols="9")
                      v-row.ml-0
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title P. Venta
                          span.product__item-amount {{item.magnitude ? item.totalSale + ' ' + item.unit : item.totalSale}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title Utilidad
                          span.product__item-amount.product__item-amount--utility {{getProductUtility(item)}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title % Utilidad
                          span.product__item-amount.product__item-amount--utility {{getPorcentualProductUtility(item)}}
                        v-col(cols="4" v-if="!item.type || item.type==='product' || item.type==='bundle'").ma-0.pa-0
                          span.product__item-title Inventario
                          span.product__item-amount {{item.stock}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title Utilidad en Inventario
                          span.product__item-amount {{getInventoryTotalUtility(item)}}
                        v-col(cols="4" v-if="!item.type || item.type==='product' || item.type==='bundle'").ma-0.pa-0
                          span.product__item-title Vendidos
                          span.product__item-amount {{item.magnitude ? item.amountTopSales + ' ' + item.unit : item.amountTopSales}}
                        v-col(v-if="shopId !== ''" cols="4").ma-0.pa-0
                          span.product__item-title T. vendido
                          span.product__item-amount {{'$ ' + item.amountTopSales * item.totalSale}}
      //- v-row.justify-center(v-if="tab < 3 && (!isMobile || (isMobile && tab >= 0))")
        v-col(cols='12' sm='6' lg='4')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='summary.purchases.isLoading' max-width='250' )
          base-material-stats-card(v-else-if="tab < 3" color='info' icon='mdi-poll' :title="$t('metrics_summary.purchases')" :value='summary.purchases.total' sub-icon='mdi-card' :sub-text="'Total en compras ' + numberFormat(summary.purchases.totalMoney)")
        v-col(cols='12' sm='6' lg='4')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='summary.expenses.isLoading' max-width='250' )
          base-material-stats-card(v-else-if="tab < 3" color='primary' icon='mdi-poll' :title="$t('metrics_summary.expenses')" :value='summary.expenses.total' sub-icon='mdi-card' :sub-text="'Total en Gastos ' + numberFormat(summary.expenses.totalMoney)")
        v-col(cols='12' sm='6' lg='4')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='summary.tranfers.isLoading' max-width='250' )
          base-material-stats-card(v-else-if="tab < 3" color='info' icon='mdi-poll' :title="$t('metrics_summary.transfers')" :value='summary.tranfers.total' sub-icon='mdi-card' sub-text='Número de traslados')
        v-col(cols='12' sm='6' lg='4')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='summary.returns.isLoading' max-width='250' )
          base-material-stats-card(v-else color='info' icon='mdi-poll' :title="'Número de devoluciones'" :value='summary.returns.total' sub-icon='mdi-card' :sub-text="'Total en devoluciones ' + numberFormat(summary.returns.totalMoney)")
      //- v-row.justify-center(v-if="tab === 3")
        v-col(cols='12' sm='6' lg='4')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='inventoryCostisLoading' max-width='250' )
          base-material-stats-card(v-else-if="!isMobile" color='info' icon='mdi-poll' title='Total invertido en inventario' :value='inventoryCost' sub-icon='mdi-card' small-value='$' sub-text='Cantidad actual en dinero invertido en el inventario')
        v-col(cols='12' sm='6' lg='4')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='loadinginventoryMetrics' max-width='250' )
          base-material-stats-card(v-else-if="!isMobile" color='info' icon='mdi-poll' title='Total cantidad vendido' :value='inventoryMetricsAmountTotal' sub-icon='mdi-card' sub-text='Cantidad de productos vendidos')
        v-col(v-if="shopId !== ''" cols='12' sm='6' lg='3')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='loadinginventoryMetrics' max-width='250' )
          base-material-stats-card(v-else-if="!isMobile" color='info' icon='mdi-poll' small-value='$' title="Total vendido" :value='inventoryMetricsTotal' sub-icon='mdi-card' sub-text='Total vendido')
        v-col(v-if="shopId !== ''" cols='12' sm='6' lg='3')
          v-skeleton-loader.mx-auto(tile type='list-item-avatar-two-line' transition='scale-transition' v-if='loadinginventoryMetrics' max-width='250' )
          base-material-stats-card(v-else-if="!isMobile" color='info' icon='mdi-poll' small-value='$' title="Total utilidad" :value='inventoryMetricsTotalUtility()' sub-icon='mdi-card' :sub-text="'Utilidad total ' + utilityPercentage + '%'")
</template>

<script> import axios from 'axios'
  import XLSX from 'xlsx'
  import Vue from 'vue'
  import DateFilter from '@/components/custom/filters/DateFilter'
  import { mapMutations, mapState } from 'vuex'
  import allCategorys from '@/assets/icons/products.png'
  import Preview from '@/components/custom/preview/ProductPreview'
  import UpdateItem from '@/views/custom/UpdateProduct'
  import * as vars from '@/vars.json'
  import moment from 'moment'
  import LineChart from '@/components/custom/charts/LineChart'
  import BarChart from '@/components/custom/charts/BarChart'
  import PieChart from '@/components/custom/charts/PieChart'
  export default {
    name: 'DashboardDashboard',
    filters: {
      timeFrom: function (date) {
        return moment(date).fromNow()
      },
      numberFormat: function (val) {
        if (val || val === 0) {
          val = parseFloat(val).toFixed(2)
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        }
        return '0'
      },
    },
    inject: ['theme'],
    components: {
      LineChart,
      BarChart,
      PieChart,
      // Create a new component that
      // extends v-skeleton-loader
      DateFilter: DateFilter,
      Preview: Preview,
      UpdateItem: UpdateItem,
      VBoilerplate: {
        functional: true,

        render (h, { data, props, children }) {
          return h('v-skeleton-loader', {
            ...data,
            props: {
              boilerplate: true,
              elevation: 2,
              ...props,
            },
          }, children)
        },
      },
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
      Movements: () => import('@/components/custom/metrics/movement_summary'),
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    props: {
      shopId: {
        type: String,
        default: () => '',
      },
      startAtInventory: {
        type: Boolean,
        default: () => false,
      },
    },
    data () {
      return {
        collaborators: {
          labels: [],
          datasets: [],
        },
        selectedShop: null,
        inventoryCost: '0',
        inventoryCostisLoading: false,
        totalAmountSalesCollabs: 0,
        dialogProductPreview: false,
        inventoryMetricsTotal: 0,
        inventoryMetricsAmountTotal: 0,
        updateItemDialog: false,
        confirmationDialog: false,
        isLastProductInshop: false,
        virtualShopsIdsToDelete: [],
        virtualShopsNamesToDelete: '',
        currentItem: {},
        isMobile: false,
        plotLoading: false,
        collabsIsLoading: false,
        tab: null,
        transition: 'scale-transition',
        allCategorys: allCategorys,
        loading: true,
        summary: {
          sales: {
            labels: [],
            datasets: [{
              label: 'Ventas',
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              data: [],
              data1: [],
            }],
          },
          purchases: {
            labels: [],
            series: [],
            totalMoney: '0',
            isLoading: false,
          },
          orders: {
            labels: [],
            datasets: [{
              label: 'Ordenes',
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
              data: [],
              data1: [],
            }],
          },
          revenue: {
            labels: [],
            datasets: [{
              label: 'Utilidad',
              borderWidth: 1,
              backgroundColor: [
                'rgba(0, 202, 227, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
              ],
              borderColor: [
                'rgba(0, 202, 227, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(255,99,132,1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
              ],
              pointBorderColor: '#2554FF',
              data: [],
            }],
          },
          expenses: {
            labels: [],
            series: [],
            totalMoney: '0',
            isLoading: false,
          },
          tranfers: {
            labels: [],
            series: [],
            isLoading: false,
          },
          returns: {
            labels: [],
            series: [],
            totalMoney: '0',
            isLoading: false,
          },
        },
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false,
        },
        menu: false,
        currentType: 'loadFilteredSummary',
        from: '',
        to: '',
        fromParent: '',
        toParent: '',
        top20Items: [],
        inventoryMetrics: [],
        loadinginventoryMetrics: false,
        // Category Analytics Data
        categoryAnalyticsLoading: false,
        categoryAnalytics: {
          daily: {},
          monthly: {},
        },
      }
    },

    computed: {
      shops () {
        return this.$store.getters['shops/getItems']
      },
      headers () {
        const vm = this
        const headersTable = [
          {
            sortable: false,
            text: 'Imagen',
            value: 'imagen',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Nombre',
            value: 'name',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Vendidos',
            value: 'sold',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Inventario',
            value: 'stock',
            align: 'left',
          },
        ]

        const headersTableInShop = [
          {
            sortable: false,
            text: 'Imagen',
            value: 'imagen',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Nombre',
            value: 'name',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Vendidos',
            value: 'sold',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Precio de venta',
            value: 'sale',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Utilidad',
            value: 'utility',
            align: 'center',
          },
          {
            sortable: true,
            text: '% Utilidad',
            value: 'porcentualutility',
            align: 'center',
          },
          {
            sortable: true,
            text: 'Total vendido',
            value: 'totalSales',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Total utilidad vendido',
            value: 'totalUtilitySale',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Inventario',
            value: 'stock',
            align: 'left',
          },
          {
            sortable: true,
            text: 'Utilidad en inventario',
            value: 'totalutility',
            align: 'left',
          },
        ]
        if (vm.shopId !== '') {
          return headersTableInShop
        } else {
          return headersTable
        }
      },
      items () {
        return ['Ventas', 'Utilidad', 'Ordenes', 'Resumen de inventario', 'Colaboradores']
      },
      utilityPercentage () {
        const invMtericsUti = this.inventoryMetricsTotalUtility()
        const invMetricsTot = this.inventoryMetricsTotal
        if (invMtericsUti === '0' || invMetricsTot === '0') {
          return '0'
        } else {
          return ((invMtericsUti * 100) / invMetricsTot).toFixed(2)
        }
      },
      ...mapState(['change']),
      optionsChartsSalesOrders () {
        const vm = this
        return {
          tooltips: {
            mode: 'label',
            callbacks: {
              label: function (tooltipItem, data) {
                // console.log(tooltipItem)
                return data.datasets[tooltipItem.datasetIndex].label + ': ' + vm.numberFormat(tooltipItem.yLabel)
              },
              title: function (tooltipItem, data) {
                return data.labels[tooltipItem[0].index]
              },

              afterLabel: function (tooltipItem, data) {
                // console.log(tooltipItem, 'tooltip')
                return 'cantidad: ' + data.datasets[tooltipItem.datasetIndex].data1[tooltipItem.index]
              },
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      optionsChartsRevenue () {
        const vm = this
        return {
          tooltips: {
            mode: 'label',
            callbacks: {
              label: function (tooltipItem, data) {
                return data.datasets[tooltipItem.datasetIndex].label + ': ' + vm.numberFormat(tooltipItem.yLabel)
              },
            },
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      optionsPieCharts () {
        const vm = this
        return {
          tooltips: {
            mode: 'label',
            callbacks: {
              label: function (tooltipItem, data) {
                // console.log(tooltipItem, data)
                return data.labels[tooltipItem.index] + ': ' + vm.numberFormat(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index])
              },
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      // Category Analytics Computed Properties
      categoryRevenueChartData () {
        const analytics = this.categoryAnalytics || { daily: {}, monthly: {} }
        const timeData = analytics.daily || {}

        if (!timeData || Object.keys(timeData).length === 0) {
          return {
            labels: [],
            datasets: [],
          }
        }

        const topCategories = this.getTopCategories(5)
        // Filter out metadata keys (those starting with "_")
        const dates = Object.keys(timeData).filter(key => !key.startsWith('_')).sort()
        const labels = dates.map(date => {
          const momentDate = Vue.moment(date)
          return momentDate.isValid() ? momentDate.format('DD/MM') : date
        })
        const colors = ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#F44336']

        const datasets = topCategories.map((category, index) => ({
          label: category.name,
          data: dates.map(date => {
            const dateData = timeData[date] || {}
            const categoryData = Object.values(dateData).find(cat =>
              (cat.categoryName || `Categoría ${cat.categoryId}`) === category.name,
            )
            return categoryData ? categoryData.totalRevenue || 0 : 0
          }),
          borderColor: colors[index],
          backgroundColor: colors[index] + '20',
          fill: false,
          tension: 0.1,
        }))

        return {
          labels,
          datasets,
        }
      },
      categoryDistributionData () {
        try {
          const topCategories = this.getTopCategories(6)
          const labels = topCategories.map(cat => cat.name)
          const data = topCategories.map(cat => cat.revenue)
          const colors = ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#F44336', '#607D8B']

          return {
            labels,
            datasets: [{
              data,
              backgroundColor: colors,
              hoverBackgroundColor: colors.map(color => color + 'CC'),
            }],
          }
        } catch (error) {
          console.error('Error in categoryDistributionData computed property:', error)
          return {
            labels: [],
            datasets: [{
              data: [],
              backgroundColor: [],
              hoverBackgroundColor: [],
            }],
          }
        }
      },
      topCategoriesHeaders () {
        return [
          { text: 'Categoría', value: 'name', sortable: true },
          { text: 'Ingresos', value: 'revenue', sortable: true, align: 'center' },
          { text: 'Transacciones', value: 'transactions', sortable: true, align: 'center' },
          { text: 'Cantidad', value: 'quantity', sortable: true, align: 'center' },
          { text: 'Crecimiento', value: 'growth', sortable: true, align: 'center' },
        ]
      },
      categoryChartOptions () {
        return {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: (tooltipItem, data) => {
                return data.datasets[tooltipItem.datasetIndex].label + ': $' +
                  this.numberFormat(tooltipItem.yLabel)
              },
            },
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: (value) => '$' + this.numberFormat(value),
              },
            }],
          },
        }
      },
      pieChartOptions () {
        return {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const label = data.labels[tooltipItem.index]
                const value = data.datasets[0].data[tooltipItem.index]
                return label + ': $' + this.numberFormat(value)
              },
            },
          },
        }
      },
      // Category Analytics Computed Properties
      categoryStats () {
        // Enhanced safety check to ensure categoryAnalytics is initialized
        try {
          if (!this.categoryAnalytics || !this.categoryAnalytics.daily) {
            return {
              totalCategories: 0,
              totalRevenue: 0,
              revenueGrowth: 0,
              avgOrderValue: 0,
            }
          }

          const analytics = this.categoryAnalytics.daily || {}

          // Use the totals calculated in the store if available
          if (analytics._totals) {
            const totals = Object.values(analytics._totals)
            const totalRevenue = totals.reduce((sum, cat) => sum + cat.totalRevenue, 0)
            const totalOrders = totals.reduce((sum, cat) => sum + cat.totalOrders, 0)
            const totalCategories = totals.length

            // Calculate overall growth
            let totalCurrentRevenue = 0
            let totalPreviousRevenue = 0

            if (analytics._previousTotals) {
              totalCurrentRevenue = totalRevenue
              totalPreviousRevenue = Object.values(analytics._previousTotals).reduce((sum, cat) => sum + cat.totalRevenue, 0)
            }

            const revenueGrowth = totalPreviousRevenue > 0
              ? Math.round(((totalCurrentRevenue - totalPreviousRevenue) / totalPreviousRevenue) * 10000) / 100
              : totalCurrentRevenue > 0 ? 100 : 0

            return {
              totalCategories,
              totalRevenue,
              revenueGrowth,
              avgOrderValue: totalOrders > 0 ? (totalRevenue / totalOrders) : 0,
            }
          }

          // Fallback to old calculation
          const categories = new Set()
          let totalRevenue = 0
          let totalOrders = 0

          Object.keys(analytics).forEach(date => {
            if (date.startsWith('_')) return // Skip metadata

            const dateData = analytics[date]
            Object.keys(dateData).forEach(categoryId => {
              const categoryData = dateData[categoryId]
              categories.add(categoryId)
              totalRevenue += categoryData.totalRevenue || 0
              totalOrders += categoryData.totalOrders || 0
            })
          })

          return {
            totalCategories: categories.size,
            totalRevenue: totalRevenue,
            revenueGrowth: 0,
            avgOrderValue: totalOrders > 0 ? (totalRevenue / totalOrders) : 0,
          }
        } catch (error) {
          console.error('Error in categoryStats computed property:', error)
          return {
            totalCategories: 0,
            totalRevenue: 0,
            revenueGrowth: 0,
            avgOrderValue: 0,
          }
        }
      },
      topCategories () {
        // Enhanced safety check to ensure categoryAnalytics is initialized
        try {
          if (!this.categoryAnalytics || !this.categoryAnalytics.daily) {
            return []
          }

          const analytics = this.categoryAnalytics.daily || {}

          // Use the totals calculated in the store if available
          if (analytics._totals) {
            return Object.values(analytics._totals)
              .map(category => {
                const categoryId = category.categoryId
                const previousCategory = analytics._previousTotals && analytics._previousTotals[categoryId] 
                  ? analytics._previousTotals[categoryId] 
                  : { totalRevenue: 0, totalOrders: 0, totalQuantity: 0 }

                return {
                  name: category.categoryName,
                  revenue: category.totalRevenue,
                  transactions: category.totalOrders,
                  quantity: category.totalQuantity,
                  growth: category.growth || 0,
                  // Período anterior
                  previousRevenue: previousCategory.totalRevenue,
                  previousTransactions: previousCategory.totalOrders,
                  previousQuantity: previousCategory.totalQuantity,
                  // Cambios absolutos
                  revenueChange: category.totalRevenue - previousCategory.totalRevenue,
                  transactionsChange: category.totalOrders - previousCategory.totalOrders,
                  quantityChange: category.totalQuantity - previousCategory.totalQuantity,
                }
              })
              .sort((a, b) => b.revenue - a.revenue)
              .slice(0, 10)
          }

          // Fallback to old calculation if _totals not available
          const categoryTotals = {}

          Object.keys(analytics).forEach(date => {
            if (date.startsWith('_')) return // Skip metadata

            const dateData = analytics[date]
            Object.keys(dateData).forEach(categoryId => {
              const categoryData = dateData[categoryId]
              const categoryName = categoryData.categoryName || `Categoría ${categoryId}`
              if (!categoryTotals[categoryName]) {
                categoryTotals[categoryName] = {
                  name: categoryName,
                  revenue: 0,
                  transactions: 0,
                  quantity: 0,
                  growth: 0,
                  // Campos del período anterior (fallback a 0)
                  previousRevenue: 0,
                  previousTransactions: 0,
                  previousQuantity: 0,
                  revenueChange: 0,
                  transactionsChange: 0,
                  quantityChange: 0,
                }
              }
              categoryTotals[categoryName].revenue += categoryData.totalRevenue || 0
              categoryTotals[categoryName].transactions += categoryData.totalOrders || 0
              categoryTotals[categoryName].quantity += categoryData.totalQuantity || 0
              categoryTotals[categoryName].growth = categoryData.growth || 0
            })
          })

          return Object.values(categoryTotals)
            .sort((a, b) => b.revenue - a.revenue)
            .slice(0, 10)
        } catch (error) {
          console.error('Error in topCategories computed property:', error)
          return []
        }
      },
      topCategoriesHeaders () {
        return [
          { text: 'Categoría', value: 'name', sortable: true },
          { text: 'Ingresos Actuales', value: 'revenue', sortable: true, align: 'right' },
          { text: 'Ingresos Anteriores', value: 'previousRevenue', sortable: true, align: 'right' },
          { text: 'Cambio en Ingresos', value: 'revenueChange', sortable: true, align: 'right' },
          { text: 'Transacciones', value: 'transactions', sortable: true, align: 'center' },
          { text: 'Trans. Anteriores', value: 'previousTransactions', sortable: true, align: 'center' },
          { text: 'Crecimiento %', value: 'growth', sortable: true, align: 'center' },
        ]
      },
      categoryChartOptions () {
        return {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function (value) {
                  return '$' + value.toLocaleString()
                },
              },
            },
          },
        }
      },
      pieChartOptions () {
        return {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
            },
          },
        }
      },
    },
    watch: {
      shopId: function (newVal, oldVal) {
        this.initialMetrics()
      },
      selectedShop: function (newVal, oldVal) {
        // console.log(newVal, oldVal)
        const vm = this
        if (newVal) {
          vm.$router.replace(`shops/${newVal.id}/metrics`)
        }
      },
    },
    created () {
      const vm = this
      vm.initialMetrics()
    },
    mounted () {
      const vm = this
      vm.onResize()
      window.addEventListener('resize', vm.onResize, { passive: true })
      if (vm.startAtInventory) {
        vm.tab = 3
      } else if (vm.isMobile) {
        vm.tab = -1
      } else {
        vm.tab = 0
      }
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    methods: {
      numberFormat (val) {
        if (val || val === 0) {
          val = parseFloat(val).toFixed(2)
          return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        }
        return '$0 '
      },
      async loadGraphic () {
        const vm = this
        // Reload sales and revenue charts for the Sales/Utility tab
        await vm.loadSummaryCharts('week', 'sales', vm.summary.sales, null, null)
        vm.summary.sales.total = (vm.summary.sales.total - vm.summary.returns.totalMoney).toFixed(0)
        await vm.loadSummaryCharts('week', 'revenue', vm.summary.revenue, null, null)
        vm.summary.revenue.total = (vm.summary.revenue.total - vm.summary.returns.returnsUtility).toFixed(0)

        // Also reload category analytics
        vm.loadCategoryAnalytics()
        vm.$forceUpdate()
      },
      customSort (items, index, isDesc) {
        const vm = this
        items.sort((a, b) => {
          if (index[0] === 'totalUtilitySale') {
            let utila
            let utilb
            if (a.type === 'ingredient') {
              utila = -1
            } else {
              utila = parseFloat(a.amountTopSales) * parseFloat(vm.getProductUtility(a).split(' ')[1])
            }
            if (b.type === 'ingredient') {
              utilb = -1
            } else {
              utilb = parseFloat(b.amountTopSales) * parseFloat(vm.getProductUtility(b).split(' ')[1])
            }
            if (!isDesc[0]) {
              return parseFloat(utila) - parseFloat(utilb)
            } else {
              return parseFloat(utilb) - parseFloat(utila)
            }
          } else if (index[0] === 'name') {
            // comparacion de cadena
            if (!isDesc[0]) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
            } else {
              return b.name.toLowerCase().localeCompare(a.name.toLowerCase())
            }
          } else if (index[0] === 'totalSales') {
            if (!isDesc[0]) {
              return parseFloat(a.amountTopSales * a.totalSale) - parseFloat(b.amountTopSales * b.totalSale)
            } else {
              return parseFloat(b.amountTopSales * b.totalSale) - parseFloat(a.amountTopSales * a.totalSale)
            }
          } else if (index[0] === 'sale') {
            if (!isDesc[0]) {
              return parseFloat(a.totalSale) - parseFloat(b.totalSale)
            } else {
              return parseFloat(b.totalSale) - parseFloat(a.totalSale)
            }
          } else if (index[0] === 'utility') {
            let utila
            let utilb
            if (a.type === 'ingredient') {
              utila = -1
            } else {
              utila = parseFloat(vm.getProductUtility(a).split(' ')[1])
            }
            if (b.type === 'ingredient') {
              utilb = -1
            } else {
              utilb = parseFloat(vm.getProductUtility(b).split(' ')[1])
            }
            if (!isDesc[0]) {
              return parseFloat(utila) - parseFloat(utilb)
            } else {
              return parseFloat(utilb) - parseFloat(utila)
            }
          } else if (index[0] === 'porcentualutility') {
            let putila
            let putilb
            if (a.type === 'ingredient') {
              putila = -1
            } else {
              putila = parseFloat(vm.getPorcentualProductUtility(a).split('%')[0])
            }
            if (b.type === 'ingredient') {
              putilb = -1
            } else {
              putilb = parseFloat(vm.getPorcentualProductUtility(b).split('%')[0])
            }
            if (!isDesc[0]) {
              return parseFloat(putila) - parseFloat(putilb)
            } else {
              return parseFloat(putilb) - parseFloat(putila)
            }
          } else if (index[0] === 'sold') {
            if (!isDesc[0]) {
              return parseFloat(a.amountTopSales) - parseFloat(b.amountTopSales)
            } else {
              return parseFloat(b.amountTopSales) - parseFloat(a.amountTopSales)
            }
          } else if (index[0] === 'stock') {
            if (!isDesc[0]) {
              return parseFloat(a.stock) - parseFloat(b.stock)
            } else {
              return parseFloat(b.stock) - parseFloat(a.stock)
            }
          }
        })
        return items
      },
      inventoryMetricsTotalUtility () {
        if (this.inventoryMetrics) {
          let totalUtilityInventory = 0
          for (const item of this.inventoryMetrics) {
            if (item.sale !== 'N/A') {
              totalUtilityInventory += parseFloat(item.amountTopSales) * (parseFloat(item.totalSalewithouttax) - parseFloat(item.buy))
            }
          }
          return totalUtilityInventory.toString()
        } else {
          return '0'
        }
      },
      onexport () {
        const vm = this
        const products = []
        if (vm.shopId !== '') {
          vm.inventoryMetrics.forEach(element => {
            const item = {}
            item.nombre = element.name
            item.tipo = element.type
            item.vendidos = element.magnitude ? element.amountTopSales + ' ' + element.unit : element.amountTopSales
            item.precio_de_venta = element.magnitude ? element.totalSale + ' ' + element.unit : element.totalSale
            item.utilidad = vm.getProductUtility(element)
            item.utilidad_porcentaje = vm.getPorcentualProductUtility(element)
            item.total_vendido = '$ ' + element.amountTopSales * element.totalSale
            item.total_utilidad_vendido = '$ ' + element.amountTopSales * parseFloat(vm.getProductUtility(element).split(' ')[1])
            item.inventario = element.stock
            item.utilidad_inventario = vm.getInventoryTotalUtility(element)
            products.push(item)
          })
        } else {
          vm.inventoryMetrics.forEach(element => {
            const item = {}
            item.nombre = element.name
            item.tipo = element.type
            item.vendidos = element.magnitude ? element.amountTopSales + ' ' + element.unit : element.amountTopSales
            item.inventario = element.stock
            products.push(item)
          })
        }
        const localFrom = vm.from === '' ? moment().subtract(6, 'days').format('YYYY-MM-DD') : vm.from
        const localTo = vm.from === '' ? moment().format('YYYY-MM-DD') : vm.to
        const fileName = 'productos_' + localFrom + '_' + localTo
        const xls = XLSX.utils.json_to_sheet(products)
        const wb = XLSX.utils.book_new() // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, xls, 'productos') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, fileName + '.xlsx') // name of the file is 'book.xlsx'
      },
      getProductUtility (item) {
        if (item.sale === 'N/A') {
          return 'N/A'
        } else {

        }
        const utilityProd = item.totalSalewithouttax - item.buy
        return '$ ' + utilityProd.toString()
      },
      getPorcentualProductUtility (item) {
        if (item.sale === 'N/A') {
          return 'N/A'
        } else {

        }
        const utilityProd = item.totalSalewithouttax - item.buy
        return (utilityProd * 100 / item.totalSalewithouttax).toFixed(2) + '%'
      },
      getInventoryTotalUtility (item) {
        if (item.sale === 'N/A') {
          return 'N/A'
        } else {

        }
        const utilityProd = (item.totalSalewithouttax - item.buy) * item.stock
        return '$ ' + utilityProd.toString()
      },
      getImage (url) {
        if (url === '') {
          return allCategorys
        } else {
          return url
        }
      },
      ...mapMutations(['setChange']),
      showItem (item) {
        // console.log(item)
        const vm = this
        if (item.deleted) {
          vm.$swal({
            icon: 'error',
            title: 'Producto eliminado',
            text: 'Este producto fue elimiando de tu inventario, por esta razon no puedes ver el detalle.',
          })
        } else {
          vm.$store.dispatch('products/setCurrentItem', item).then(function () {
            vm.currentItem = vm.$store.getters['products/getCurrentItem'] // item no tiene la estructura de bd
            vm.dialogProductPreview = true
          })
        }
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
      editItem (item) {
        const vm = this
        this.$store.dispatch('products/setCurrentItem', { context: 'properties', id: item.id }).then(function () {
          vm.updateItemDialog = true
          vm.dialogProductPreview = false
        })
      },
      openDeleteDialog () {
        const vm = this
        vm.confirmationDialog = true
        const locations = vm.currentItem.location
        if (vm.currentItem.type !== 'ingredient') {
          for (const key in locations) {
            if (Object.prototype.hasOwnProperty.call(locations, key)) {
              const itemShop = locations[key]
              const inventoryLength = vm.$store.getters['products/getItems']
                .filter(item => !!(item.location && item.location[key]) && item.type !== 'ingredient') || []
              if (inventoryLength.length === 1) {
                vm.isLastProductInshop = true
                vm.virtualShopsIdsToDelete.push(key)
                vm.virtualShopsNamesToDelete += itemShop.name + ','
              }
            }
          }
        }
      },
      deleteItem (currentItem) {
        const vm = this
        vm.$store.dispatch('products/deleteItem', currentItem).then(function () {
          vm.confirmationDialog = false
          vm.dialogProductPreview = false
          if (vm.isLastProductInshop) {
            vm.virtualShopsIdsToDelete.forEach(el => {
              vm.$store.dispatch('shops/deleteVirtualShop', el.id).then(res => {
                vm.virtualShopsNamesToDelete = ''
                vm.isLastProductInshop = false
              })
            })
            vm.virtualShopsIdsToDelete = []
          }
        },
        ).catch(function () {
          vm.confirmationDialog = false
          vm.dialogProductPreview = false
        })
      },
      async initialMetrics () {
        const vm = this
        this.loading = true
        this.loadinginventoryMetrics = true
        vm.inventoryCostisLoading = true
        vm.$store.dispatch('loading/setLoading', true)
        vm.loadSummaryCharts('week', 'orders', vm.summary.orders, null, null)

        vm.loadSummaryCharts('week', 'purchases', vm.summary.purchases, null, null)
        vm.loadSummaryCharts('week', 'expenses', vm.summary.expenses, null, null)
        vm.loadSummaryCharts('week', 'transfers', vm.summary.tranfers, null, null)

        const info = {
          dates: null,
          userId: this.$store.state.users.user.uid,
          shopId: this.shopId,
          context: 'metrics',
        }
        this.$store.dispatch('summary/top20Products', info).then(res => {
          this.loading = false
          if (res) {
            this.top20Items = res
          }
        })

        const infoInv = {
          dates: null,
          userId: this.$store.state.users.user.uid,
          shopId: this.shopId,
          context: 'inventoryMetrics',
        }
        this.$store.dispatch('summary/top20Products', infoInv).then(res => {
          this.loadinginventoryMetrics = false
          if (res) {
            this.inventoryMetrics = res.items
            this.inventoryMetricsTotal = res.total.toString()
            this.inventoryMetricsAmountTotal = res.totalAmount.toString()
          }
        })

        const infoInvCost = {
          userId: this.$store.state.users.user.uid,
          shopId: this.shopId,
        }
        this.$store.dispatch('summary/inventoryCost', infoInvCost).then(res => {
          vm.inventoryCostisLoading = false
          // console.log(res)
          this.loadinginventoryMetrics = false
          if (res && res.totalCost) {
            this.inventoryCost = res.totalCost.toString() || '0'
          }
        })

        vm.getCollaboratorsMetrics(null, 'week')
        await vm.loadSummaryCharts('week', 'returns', vm.summary.returns, null, null)
        await vm.loadSummaryCharts('week', 'sales', vm.summary.sales, null, null)
        vm.summary.sales.total = (vm.summary.sales.total - vm.summary.returns.totalMoney).toFixed(0)
        await vm.loadSummaryCharts('week', 'revenue', vm.summary.revenue, null, null)
        vm.summary.revenue.total = (vm.summary.revenue.total - vm.summary.returns.returnsUtility).toFixed(0)

        // Load category analytics
        vm.loadCategoryAnalytics()
        vm.$forceUpdate()
      },
      async filterSummary (dates) {
        let preset
        this.loading = true
        this.loadinginventoryMetrics = true
        if (dates) {
          this.menu = false
          this.from = moment(dates.from).format('DD-MM-YYYY')
          this.to = moment(dates.to).subtract(1, 'days').format('DD-MM-YYYY')
          this.fromParent = moment(dates.from).format('YYYY-MM-DD')
          this.toParent = moment(dates.to).subtract(1, 'days').format('YYYY-MM-DD')
          const momentFrom = moment(dates.from)
          const momentTo = moment(dates.to)
          const differenceInDays = momentTo.diff(momentFrom, 'days')
          // este preset es para los labels. No es para calcular fechas
          if (differenceInDays === 1) {
            preset = 'today'
          } else if (differenceInDays <= 7) {
            preset = 'week'
          } else if (differenceInDays <= 31) {
            preset = 'month'
          } else {
            preset = 'year'
          }
        } else {
          this.from = ''
          this.to = ''
        }
        const vm = this
        vm.$store.dispatch('loading/setLoading', true)
        vm.loadSummaryCharts(dates ? preset : 'week', 'orders', vm.summary.orders, dates ? dates.from : null, dates ? dates.to : null)
        vm.loadSummaryCharts(dates ? preset : 'week', 'purchases', vm.summary.purchases, dates ? dates.from : null, dates ? dates.to : null)
        vm.loadSummaryCharts(dates ? preset : 'week', 'expenses', vm.summary.expenses, dates ? dates.from : null, dates ? dates.to : null)
        vm.loadSummaryCharts(dates ? preset : 'week', 'transfers', vm.summary.tranfers, dates ? dates.from : null, dates ? dates.to : null)
        const info = {
          dates: dates,
          userId: this.$store.state.users.user.uid,
          shopId: this.shopId,
          context: 'metrics',
        }
        this.$store.dispatch('summary/top20Products', info).then(res => {
          this.loading = false
          // console.log('prodstop20', res)
          if (res) {
            this.top20Items = res
          }
        })

        const infoInv = {
          dates: dates,
          userId: this.$store.state.users.user.uid,
          shopId: this.shopId,
          context: 'inventoryMetrics',
        }
        this.$store.dispatch('summary/top20Products', infoInv).then(res => {
          this.loadinginventoryMetrics = false
          if (res) {
            this.inventoryMetrics = res.items
            this.inventoryMetricsTotal = res.total.toString()
            this.inventoryMetricsAmountTotal = res.totalAmount.toString()
          }
        })
        vm.getCollaboratorsMetrics(dates, preset)
        await vm.loadSummaryCharts(dates ? preset : 'week', 'returns', vm.summary.returns, dates ? dates.from : null, dates ? dates.to : null)
        await vm.loadSummaryCharts(dates ? preset : 'week', 'sales', vm.summary.sales, dates ? dates.from : null, dates ? dates.to : null)
        vm.summary.sales.total = (vm.summary.sales.total - vm.summary.returns.totalMoney).toFixed(0)
        await vm.loadSummaryCharts(dates ? preset : 'week', 'revenue', vm.summary.revenue, dates ? dates.from : null, dates ? dates.to : null)
        vm.summary.revenue.total = (vm.summary.revenue.total - vm.summary.returns.returnsUtility).toFixed(0)

        // Load category analytics with filtered dates
        vm.loadCategoryAnalytics(dates ? dates.from : null, dates ? dates.to : null)

        vm.$forceUpdate()
      },
      dateSelected (dates, type, callback) {
        // this.$store.dispatch('loading/setLoading',true);
        // console.log(dates)
        axios.post(vars.url + '/summarySales', {
          user_id: this.$store.getters.activeUser.uid,
          dateFrom: dates.dateFrom,
          dateTo: dates.dateTo,
        }).then(res => {
          // console.log(res.data)
          this.request = res.data
          // //this.$store.dispatch('loading/setLoading',false);
        }).catch(e => {
          // console.log(e)
        })
        this.menu = false
      },
      update () {
        // this.$store.dispatch('loading/setLoading',true);
        axios.post(vars.url + '/summarySales', {
          user_id: this.$store.getters.activeUser.uid,
        }).then(res => {
          // console.log(res.data)
          this.res = res.data
          // //this.$store.dispatch('loading/setLoading',false);
        }).catch(e => {
          // console.log(e)
        })
      },
      complete (index) {
        this.list[index] = !this.list[index]
      },
      async loadSummaryCharts (preset, type, callback, from, to) {
        const vm = this
        callback.isLoading = true
        if (type === 'returns') {
          vm.summary.sales.isLoading = true
          vm.summary.revenue.isLoading = true
        }
        await axios.post(vars.url + '/summarySales', {
          user_id: vm.$store.state.users.user.uid,
          preset: preset,
          type: type,
          dateFrom: from,
          dateTo: to,
          shopId: vm.shopId,
        }).then(res => {
          // mejorar, de manera que se pueda obtener el valor y el revenue
          if (type === 'sales' || type === 'revenue' || type === 'orders') {
            callback.labels = Object.keys(res.data.resultsCost)
            callback.datasets[0].data = Object.values(res.data.resultsCost)
            if (type === 'sales' || type === 'orders') {
              callback.datasets[0].data1 = Object.values(res.data.results)
            }
            callback.total = res.data.total
          } else {
            callback.labels = Object.keys(res.data.results)
            callback.series = [Object.values(res.data.results)]
            if (type === 'returns') {
              callback.totalMoney = Object.values(res.data.resultsCost).reduce((a, b) => a + b, 0)
              callback.returnsUtility = res.data.total
            }
            callback.total = (Object.values(res.data.results).reduce((a, b) => a + b, 0)).toString()
            if (type === 'purchases' || type === 'expenses') {
              // la funcion summarySales solo devulve total money para estos tipos
              callback.totalMoney = res.data.totalMoney
            }
          }
          callback.isLoading = false
          vm.$forceUpdate()
          vm.$store.dispatch('summary/setChart', [type, callback])
        }).catch(e => {
          callback.isLoading = false
          // console.log(e)
        })
      },
      getCollaboratorsMetrics (dates, preset) {
        const vm = this
        vm.collabsIsLoading = true
        const collabs = {
          dates: dates,
          userId: this.$store.state.users.user.uid,
          shopId: this.shopId,
          preset: preset,
        }
        this.$store.dispatch('summary/summaryByCollaborator', collabs).then(res => {
          // console.log(res.data)
          vm.collaborators = res.data.collaboratorsData
          vm.totalAmountSalesCollabs = res.data.amountSales
          vm.collabsIsLoading = false
        })
      },
      // Category Analytics Methods
      loadCategoryAnalytics (fromDate = null, toDate = null) {
        this.categoryAnalyticsLoading = true

        let dateFrom, dateTo

        if (fromDate && toDate) {
          dateFrom = moment(fromDate).format('YYYY-MM-DD')
          dateTo = moment(toDate).format('YYYY-MM-DD')
        } else {
          dateFrom = this.from ? moment(this.from, 'DD-MM-YYYY').format('YYYY-MM-DD') : moment().subtract(6, 'days').format('YYYY-MM-DD')
          dateTo = this.to ? moment(this.to, 'DD-MM-YYYY').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        }

        this.$store.dispatch('summary/loadCategoryAnalytics', {
          timeRange: 'daily',
          dateFrom,
          dateTo,
        }).then(data => {
          this.categoryAnalytics.daily = data || {}
          this.categoryAnalyticsLoading = false
        }).catch(error => {
          console.error('Error loading category analytics:', error)
          this.categoryAnalyticsLoading = false
        })
      },
      formatDateRange (from, to) {
        if (!from || !to) return 'N/A'
        const fromMoment = moment(from)
        const toMoment = moment(to)

        if (!fromMoment.isValid() || !toMoment.isValid()) {
          return 'N/A'
        }

        const fromFormatted = fromMoment.format('DD/MM/YYYY')
        const toFormatted = toMoment.format('DD/MM/YYYY')
        return `${fromFormatted} - ${toFormatted}`
      },
      getTopCategories (limit = 10) {
        const analytics = this.categoryAnalytics || { daily: {}, monthly: {} }
        const timeData = analytics.daily || {}

        // First, try to use the pre-calculated totals from the store
        if (timeData._totals) {
          return Object.values(timeData._totals)
            .map(category => ({
              name: category.categoryName,
              revenue: category.totalRevenue,
              transactions: category.totalOrders,
              quantity: category.totalQuantity,
              growth: category.growth || 0,
            }))
            .sort((a, b) => b.revenue - a.revenue)
            .slice(0, limit)
        }

        // Fallback calculation if _totals not available
        if (!timeData || Object.keys(timeData).length === 0) {
          return []
        }

        const categoryTotals = {}
        // Filter out metadata keys (those starting with "_")
        const validDates = Object.keys(timeData).filter(key => !key.startsWith('_'))

        validDates.forEach(date => {
          const dateData = timeData[date]
          Object.keys(dateData).forEach(categoryId => {
            const categoryData = dateData[categoryId]
            const categoryName = categoryData.categoryName || `Categoría ${categoryId}`
            if (!categoryTotals[categoryName]) {
              categoryTotals[categoryName] = {
                name: categoryName,
                revenue: 0,
                transactions: 0,
                quantity: 0,
                growth: 0,
              }
            }
            categoryTotals[categoryName].revenue += categoryData.totalRevenue || 0
            categoryTotals[categoryName].transactions += categoryData.totalOrders || 0
            categoryTotals[categoryName].quantity += categoryData.totalQuantity || 0
            categoryTotals[categoryName].growth = categoryData.growth || 0
          })
        })

        return Object.values(categoryTotals)
          .sort((a, b) => b.revenue - a.revenue)
          .slice(0, limit)
      },
      calculateGrowth (currentValue) {
        // For category analytics, growth is already calculated in the store
        // This method is now only used for fallback scenarios
        return 0 // Default to 0 if no growth data available
      },
    },
  }
</script>

<style lang="scss" scoped>

$main-purple: #7957d5;
$secondary-purple:#DED4F8;
$main-color: #3cbbc2;
$main-blue: #108bc2;
$nav-color:  rgba(0, 158, 169, 0.54);
$content-bg: #ecedef;
$content-bg-transparent: rgba(#ecedef,0.7);
//navbar
$navbar-mobile-height: 80px;
$card-height: 152px;
$card-width: 130px;
$out-of-stock-color: #9d0707;

.small{
  height: 300px !important;
  width: 100% !important;
}

.summary-container{
  .card-tabs{

    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .product-card {
    flex-direction: column;
    min-height:$card-height;
    // max-height:$card-height;
    min-width: $card-width;
    max-width: 190px;

    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.2);

    overflow: hidden;
    transition: .3s;
    user-select: none;

    &__content {
      display: flex;
      flex-direction: row;

    }
    &__left, &__right {
      display: flex;
      flex-direction: column;

    }
    &__left {
      align-items: center;
      width: calc(100% - 35px);
    }
    &__right {
      min-width: 35px;
      margin-left: auto;
    }
    &__tag {
      line-height: 10px;
      border-bottom: 1px dotted rgba(#000, 0.4);
      padding: 5px;
      text-align: center;
      font-size: 10px;
      font-weight: 500;
      position: relative;
      z-index: 0;
      min-height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before, &:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        background: #d2d3d5;
        bottom: -4px;
        border-radius: 50%;
        z-index: 1;

      }
      &:before {
        left: -4px;
      }
      &:after {
        right: -4px;
      }
    }

    &__stock {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 5px 2px;
      border-radius: 4px;
      margin: 10px 5px 5px;
      background: $content-bg;
      &--out{
        background: $out-of-stock-color;
        color: #fff;
      }
      span {
        font-size: 10px;
      }
      p {
        font-size: 22px;
        font-weight: bold;

      }

    }
    &__background {
      padding: 5px 5px 0;
      position: relative;
      text-align: center;
      img {
        height: 60px;
        object-fit: contain;
      }
    }
    &__money-tag {
      color: $main-color;
      font-size: 18px;
      font-weight: 800;
    }
    &__description {
      display: flex;
      justify-content: center;
      flex-direction: row;
      flex-wrap: nowrap;
      text-align: left;
      padding: 0 3px !important;
      margin: 8px;

      p {
        font-size: 18px;
        font-weight: 800;
      }
    }
    &__addBtn{
      display: flex;
      justify-content: flex-end;
      margin-top: auto;
      width: 44px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      &:hover{
        cursor:pointer;
        transform: scale(1.2);

      }

      &-container{
        width: 80px;
        height: 80px;
        margin-right: -40px;
        margin-bottom: -40px;
        background: $main-color;
        color: #ffF;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 800;
        padding-left: 13px;

      }
      &--out{
        .product-card__addBtn-container{
          background: $out-of-stock-color;
        }

        img{
          width: 20px;
          height: 20px;
        }
      }
      span{

      }
    }
    .card-content {
      display: flex;
      max-height: 50px;
      min-height: 50px;
    }
    &--animated{
      &:hover {
        -webkit-animation: pulse .3s;
        animation: pulse .3s;
      }
    }
    &--full{

      max-width: 300px;
      width: 100%;
      min-width: 250px;

      .product-card__left{
        justify-content: center;
        align-items: center;
      }
      .product-card__left,  .product-card__right{
        flex:1;
      }
      .product-card__stock{
        margin: 0;
        padding: 0;
        flex-direction: row;
        flex-wrap: nowrap;
        background: transparent;
        span,p{
          font-size: 12px;
        }
        p{
          margin-left: 5px;
        }
      }
      .product-card__background{
        text-align: center;
        img{
          height: 100px;
          object-fit: contain;
        }
      }
      .product-card__description{
        margin: 0;
        color : $main-color;

      }
    }
  }
  @media(min-width: 760px) {
    .show-table-mobile{
      display: none !important;
    }
    .show-table-desktop{
      display: block !important;
    }
  }
  @media(max-width: 1100px) {
    .show-table-mobile{
      display: flex !important;
    }
    .show-table-desktop{
      display: none !important;
    }
  }
}

.wine-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 370px;
  padding: 0 5px;
  position: relative;
  align-content: flex-start;
  &.cart-container {
    max-height: unset;
  }
  .wine-card, .product-card {
    display: flex;
    position: relative;
    // max-height: $card-height;
    height: $card-height;
    // max-width: $card-width;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    padding: 0;
    margin: 5px;
    flex: 1;
    transition: .3s;

    .card-image {
      align-items: center;
      justify-content: center;
      display: flex;
    }

    .card-content {
      padding: 0;
      background: rgba(#000, 0.7);
      color: #fff;
      font-size: 9px;
      font-weight: bold;
      z-index: 1;
      position: relative;
      bottom: 0;
      margin-top: auto;
      flex: 1;
      max-height: 50px;
      @media (min-width: 768px) {
        font-size: 10px;
      }
      .card-description {
        padding: 5px;
      }
    }
    .card-background {
      position: absolute;
      width: 100%;
      height: 100%;

      z-index: 0;
      img {
        z-index: 0;
        height: 100%;
        width: 100%;
        object-fit: contain;

      }
    }
  }
  .product-card {
    flex-direction: column;
    min-height:$card-height;
    max-height:$card-height;
    min-width: $card-width;

    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.2);

    overflow: hidden;
    transition: .3s;
    user-select: none;

    &__content {
      display: flex;
      flex-direction: row;

    }
    &__left, &__right {
      display: flex;
      flex-direction: column;

    }
    &__left {
      align-items: center;
      width: calc(100% - 35px);
    }
    &__right {
      min-width: 35px;
      margin-left: auto;
    }
    &__tag {
      line-height: 10px;
      border-bottom: 1px dotted rgba(#000, 0.4);
      padding: 5px;
      text-align: center;
      font-size: 10px;
      font-weight: 500;
      position: relative;
      z-index: 0;
      min-height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before, &:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        background: #d2d3d5;
        bottom: -4px;
        border-radius: 50%;
        z-index: 1;

      }
      &:before {
        left: -4px;
      }
      &:after {
        right: -4px;
      }
    }

    &__stock {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 5px 2px;
      border-radius: 4px;
      margin: 10px 5px 5px;
      background: $content-bg;
      &--out{
        background: $out-of-stock-color;
        color: #fff;
      }
      span {
        font-size: 10px;
      }
      p {
        font-size: 22px;
        font-weight: bold;

      }

    }
    &__background {
      padding: 5px 5px 0;
      position: relative;
      text-align: center;
      img {
        height: 60px;
        object-fit: contain;
      }
    }
    &__money-tag {
      color: $main-color;
      font-size: 18px;
      font-weight: 800;
    }
    &__description {
      display: flex;
      justify-content: center;
      flex-direction: row;
      flex-wrap: nowrap;
      text-align: left;
      padding: 0 3px !important;
      margin: 8px;

      p {
        font-size: 18px;
        font-weight: 800;
      }
    }
    &__addBtn{
      display: flex;
      justify-content: flex-end;
      margin-top: auto;
      width: 44px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      &:hover{
        cursor:pointer;
        transform: scale(1.2);

      }

      &-container{
        width: 80px;
        height: 80px;
        margin-right: -40px;
        margin-bottom: -40px;
        background: $main-color;
        color: #ffF;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 800;
        padding-left: 13px;

      }
      &--out{
        .product-card__addBtn-container{
          background: $out-of-stock-color;
        }

        img{
          width: 20px;
          height: 20px;
        }
      }
      span{

      }
    }
    .card-content {
      display: flex;
      max-height: 50px;
      min-height: 50px;
    }
    &--animated{
      &:hover {
        -webkit-animation: pulse .3s;
        animation: pulse .3s;
      }
    }
    &--full{

      max-width: 300px;
      width: 100%;
      min-width: 250px;

      .product-card__left{
        justify-content: center;
        align-items: center;
      }
      .product-card__left,  .product-card__right{
        flex:1;
      }
      .product-card__stock{
        margin: 0;
        padding: 0;
        flex-direction: row;
        flex-wrap: nowrap;
        background: transparent;
        span,p{
          font-size: 12px;
        }
        p{
          margin-left: 5px;
        }
      }
      .product-card__background{
        text-align: center;
        img{
          height: 100px;
          object-fit: contain;
        }
      }
      .product-card__description{
        margin: 0;
        color : $main-color;

      }
    }
  }
}
.product {
  position: relative;
  background: #e0e0e0;
  padding: 0;
  margin: 0 5px;
  border-radius: 10px;
  border-bottom-right-radius: 80px;

  &__title-area {
    background: #008f96;
    border-radius: 10px;
    padding: 3px;

    &--product {
      background:  #008f96 !important;
    }

    &--service {
      background:#d62828 !important;
    }

    &--bundle {
      background: #f77f00 !important;
    }

    &--ingredient {
      background: #fcbf49 !important;
    }
  }

  &__title {
    color: #fff;
  }

  &__title--table {
    font-size: 1.2rem;
    max-width: 250px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    @media (max-width: 1500px) {
      font-size: 1rem;
      max-width: 200px;
    }

    @media (max-width: 1300px) {
      font-size: 1rem;
      max-width: 160px;
    }
  }

  &__img {
    display: block;
    height: 6.125rem;
    width: 6.125rem;
    object-fit: cover;
    margin: auto;
    box-shadow: 1px 3px 3px rgba(0,0,0,0.3);
    border-radius: 10px;
  }

  &__item-title {
    font-size: 0.7rem;
    color:#a7a8a8;
    display: block;
  }

  &__item-amount {
    font-size: 0.7rem;
    font-weight: 800;
    color: #000;

    &--utility {
      width: 2rem;
      color:#4CAF50;
      display: inline-flex;
    }
  }
}
.metrics {
  &__title {
    text-align: center;
    color:#a3a4a5;
    margin-bottom: 1.5rem;
    font-size: 2rem;
  }

  &__underline {
    position: relative;

    &:after {
      content:' ';
      position: absolute;
      top:120%;
      left:50%;
      width: 8rem;
      border:2px solid #30b5bb;
      border-radius:4px;
      transform:translateX(-50%);
    }
  }
}
</style>
